// extracted by mini-css-extract-plugin
export default {"body":"Salidas_body__eckNA","content":"Salidas_content__FlIK7","menuGroup":"Salidas_menuGroup__cH6YG"};